import { render } from "./VideoAndImageView.vue?vue&type=template&id=047fef4f&scoped=true"
import script from "./VideoAndImageView.vue?vue&type=script&lang=js"
export * from "./VideoAndImageView.vue?vue&type=script&lang=js"

import "./VideoAndImageView.vue?vue&type=style&index=0&id=047fef4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047fef4f"]])

export default __exports__